/// <reference path="../_all.ts" />

module user {

  export function LoginHeaderDirective(): ng.IDirective {
    return {
      restrict: 'AE',
      scope: {
        showLogin : '='
      },
      templateUrl: 'user/LoginHeaderDirective',
      link: function (scope: ILoginHeaderScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        scope.mode = 'login';
        scope.close = function() {
          scope.showLogin = false;
        }
        scope.setProgress = (progress : boolean) => {
          scope.requestOnGoing = progress;
        }
      }
    }
  }

}